import { render } from "./PoiMarker.vue?vue&type=template&id=04df16c0"
import script from "./PoiMarker.vue?vue&type=script&lang=js"
export * from "./PoiMarker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__